import { EntityModel } from '@/interfaces'
import {
  ALL_PAGES_QUERY,
  CREATE_PAGE_MUTATION,
  DELETE_PAGE_MUTATION,
  FORCE_DELETE_PAGE_MUTATION,
  SINGLE_PAGE_QUERY,
  UPDATE_PAGE_MUTATION,
} from './graphql'
import elementSeoSettingsEntity from '@/entities/elementSeoSettings/entity'
import cmsContentBlockAssignmentEntity from '@/entities/cmsContentBlockAssignment/entity'

const cmsPageModel: EntityModel = {
  name: 'page',
  namePlural: 'pages',
  uniqueName: 'cmsPage',
  uniqueNamePlural: 'cmsPages',
  path: 'cms/page',
  baseUrl: '/cms/pages',
  translationPrefix: 'entities:cmsPage.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_PAGES_QUERY,
    getSingle: SINGLE_PAGE_QUERY,
    create: CREATE_PAGE_MUTATION,
    update: UPDATE_PAGE_MUTATION,
    delete: DELETE_PAGE_MUTATION,
    forceDelete: FORCE_DELETE_PAGE_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:cmsPage.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    onlineStatus: {
      name: 'onlineStatus',
      label: 'entities:cmsPage.attributes.onlineStatus.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'ONLINE',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsPage.attributes.onlineStatus.selectOptions.ONLINE.label',
          value: 'ONLINE',
        },
        {
          label: 'entities:cmsPage.attributes.onlineStatus.selectOptions.HIDDEN.label',
          value: 'HIDDEN',
        },
        {
          label: 'entities:cmsPage.attributes.onlineStatus.selectOptions.OFFLINE.label',
          value: 'OFFLINE',
        },
      ],
      validationType: 'string',
      validations: [],
    },
    seoSettings: {
      name: 'seoSettings',
      label: 'entities:cmsPage.attributes.seoSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return elementSeoSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    contentBlockAssignments: {
      name: 'contentBlockAssignments',
      label: 'entities:cmsPage.attributes.contentBlockAssignments.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsContentBlockAssignmentEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsPageModel
